import {
    SET_AUTHENTICATING,
    SET_LOADING,
    SET_LOADING_SUBSTANCES,
    SET_MESSAGE,
    SET_OFFLINE_DOWNLOAD_COMPLETE
} from "../actions/status";

const initialState = {
    message: null,
    authenticating: false,
    loading: false,
    offlineDownloadComplete: false,
    loadingSubstances: false
};

export default function statusReducer(state = initialState, action) {
    switch (action.type) {
        case SET_AUTHENTICATING:
            return Object.assign({}, state, {
                authenticating: action.payload
            });
        case SET_LOADING:
            return Object.assign({}, state, {
                loading: action.payload
            });
        case SET_LOADING_SUBSTANCES:
            return Object.assign({}, state, {
                loadingSubstances: action.payload
            });
        case SET_MESSAGE:
            return Object.assign({}, state, {
                message: action.payload
            });
        case SET_OFFLINE_DOWNLOAD_COMPLETE:
            return Object.assign({}, state, {
                offlineDownloadComplete: action.payload
            });
        case 'DOWNLOAD_OFFLINE_DATA_REQUEST':
            return {
                ...state,
                loading: true,
                message: null,
            };
        case 'DOWNLOAD_OFFLINE_DATA_SUCCESS':
            return {
                ...state,
                loading: false,
                offlineDownloadComplete: true,
                message: { message: 'Téléchargement terminé avec succès !', status: 'success' },
            };
        case 'DOWNLOAD_OFFLINE_DATA_FAILURE':
            return {
                ...state,
                loading: false,
                offlineDownloadComplete: false,
                message: { message: `Erreur : ${action.payload}`, status: 'error' },
            };
        default:
            return state;
    }
}
